const menu = [
	{
		heading: 'MENU',
	},
	{
		name: 'Escritorio',
		path: '/home',
		icon: 'ri-home-8-line',
		permission: 'home-index',
	},
	{
		name: 'Mis postulaciones',
		path: '/postulant/requirements/index',
		icon: 'ri-lock-line',
		permission: 'home-index',
	},
];

export default menu;
